import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { getAssetUrl as e } from "../../assets.js";
import r from "../../config.js";
import "../../intl.js";
import { version as o } from "../../kernel.js";
import t from "../has.js";
import s from "../Logger.js";
import { makeAbsolute as i } from "../urlUtils.js";
import n from "./loaderConfig.js";
import { receiveMessage as a, MessageType as l } from "./utils.js";
import f from "./WorkerFallback.js";
import { getLocale as c } from "../../intl/locale.js";
import { buildDate as d, commitHash as u } from "../../support/revision.js";
var m = s.getLogger("esri.core.workers"),
    p = l.HANDSHAKE,
    g = 'let globalId=0;const outgoing=new Map,configuration=JSON.parse("{CONFIGURATION}");self.esriConfig=configuration.esriConfig;const workerPath=self.esriConfig.workers.workerPath,HANDSHAKE=0,OPEN=1,OPENED=2,RESPONSE=3,INVOKE=4,ABORT=5;function createAbortError(){const e=new Error("Aborted");return e.name="AbortError",e}function receiveMessage(e){return e&&e.data?"string"==typeof e.data?JSON.parse(e.data):e.data:null}function invokeStaticMessage(e,o,r){const t=r&&r.signal,n=globalId++;return new Promise(((r,i)=>{if(t){if(t.aborted)return i(createAbortError());t.addEventListener("abort",(()=>{outgoing.get(n)&&(outgoing.delete(n),self.postMessage({type:5,jobId:n}),i(createAbortError()))}))}outgoing.set(n,{resolve:r,reject:i}),self.postMessage({type:4,jobId:n,methodName:e,abortable:null!=t,data:o})}))}let workerRevisionChecked=!1;function checkWorkerRevision(e){if(!workerRevisionChecked&&e.kernelInfo){workerRevisionChecked=!0;const{revision:o,buildDate:r,version:t}=configuration.kernelInfo,{revision:n,buildDate:i,version:s}=e.kernelInfo;o!==n&&console.warn(`[esri.core.workers] Version mismatch detected between ArcGIS API for JavaScript and assets:\nAPI version: ${t} [Date: ${r}, Revision: ${o.slice(0,8)}]\nAssets version: ${s} [Date: ${i}, Revision: ${n.slice(0,8)}]`)}}function messageHandler(e){const o=receiveMessage(e);if(!o)return;const r=o.jobId;switch(o.type){case 1:let e;function t(o){const t=e.connect(o);self.postMessage({type:2,jobId:r,data:t},[t])}"function"==typeof define&&define.amd?require([workerPath],(r=>{e=r.default||r,checkWorkerRevision(e),e.loadWorker(o.modulePath).then((e=>e||new Promise((e=>{require([o.modulePath],e)})))).then(t)})):"System"in self&&"function"==typeof System.import?System.import(workerPath).then((r=>(e=r.default,checkWorkerRevision(e),e.loadWorker(o.modulePath)))).then((e=>e||System.import(o.modulePath))).then(t):(self.RemoteClient||importScripts(workerPath),e=self.RemoteClient.default||self.RemoteClient,checkWorkerRevision(e),e.loadWorker(o.modulePath).then(t));break;case 3:if(outgoing.has(r)){const e=outgoing.get(r);outgoing.delete(r),o.error?e.reject(JSON.parse(o.error)):e.resolve(o.data)}}}self.dojoConfig=configuration.loaderConfig,esriConfig.workers.loaderUrl&&(self.importScripts(esriConfig.workers.loaderUrl),"function"==typeof require&&"function"==typeof require.config&&require.config(configuration.loaderConfig)),self.addEventListener("message",messageHandler),self.postMessage({type:0});';
var k, h;
var w = "Failed to create Worker. Fallback to execute module in main thread";

function v() {
  return _v.apply(this, arguments);
}

function _v() {
  _v = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _e2, e;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (t("esri-workers")) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", y(new f()));

          case 2:
            if (!k && !h) try {
              _e2 = g.replace('"{CONFIGURATION}"', "'".concat(b(), "'"));
              k = URL.createObjectURL(new Blob([_e2], {
                type: "text/javascript"
              }));
            } catch (r) {
              h = r || {};
            }
            if (k) try {
              e = new Worker(k, {
                name: "esri-worker-" + P++
              });
            } catch (r) {
              m.warn(w, h), e = new f();
            } else m.warn(w, h), e = new f();
            return _context.abrupt("return", y(e));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _v.apply(this, arguments);
}

function y(_x) {
  return _y.apply(this, arguments);
}

function _y() {
  _y = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (r) {
              function o(s) {
                var i = a(s);
                i && i.type === p && (e.removeEventListener("message", o), e.removeEventListener("error", t), r(e));
              }

              function t(r) {
                r.preventDefault(), e.removeEventListener("message", o), e.removeEventListener("error", t), m.warn("Failed to create Worker. Fallback to execute module in main thread", r), (e = new f()).addEventListener("message", o), e.addEventListener("error", t);
              }

              e.addEventListener("message", o), e.addEventListener("error", t);
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _y.apply(this, arguments);
}

function b() {
  var s;

  if (null != r.default) {
    var _e = _objectSpread({}, r);

    delete _e.default, s = JSON.parse(JSON.stringify(_e));
  } else s = JSON.parse(JSON.stringify(r));

  s.assetsPath = i(s.assetsPath), s.request.interceptors = [], s.log.interceptors = [], s.locale = c(), s.has = {
    "esri-csp-restrictions": t("esri-csp-restrictions"),
    "esri-2d-debug": !1,
    "esri-2d-update-debug": t("esri-2d-update-debug"),
    "esri-2d-query-centroid-enabled": t("esri-2d-query-centroid-enabled"),
    "featurelayer-pbf": t("featurelayer-pbf"),
    "featurelayer-simplify-thresholds": t("featurelayer-simplify-thresholds"),
    "featurelayer-simplify-payload-size-factors": t("featurelayer-simplify-payload-size-factors"),
    "featurelayer-simplify-mobile-factor": t("featurelayer-simplify-mobile-factor"),
    "esri-atomics": t("esri-atomics"),
    "esri-shared-array-buffer": t("esri-shared-array-buffer"),
    "esri-tiles-debug": t("esri-tiles-debug"),
    "esri-workers-arraybuffer-transfer": t("esri-workers-arraybuffer-transfer"),
    "host-webworker": 1
  }, s.workers.loaderUrl && (s.workers.loaderUrl = i(s.workers.loaderUrl)), s.workers.workerPath ? s.workers.workerPath = i(s.workers.workerPath) : s.workers.workerPath = i(e("esri/core/workers/RemoteClient.js"));
  var a = r.workers.loaderConfig,
      l = n({
    baseUrl: null == a ? void 0 : a.baseUrl,
    locale: c(),
    has: _objectSpread({
      "csp-restrictions": 1,
      "dojo-test-sniff": 0,
      "host-webworker": 1
    }, null == a ? void 0 : a.has),
    map: _objectSpread({}, null == a ? void 0 : a.map),
    paths: _objectSpread({}, null == a ? void 0 : a.paths),
    packages: (null == a ? void 0 : a.packages) || []
  }),
      f = {
    version: o,
    buildDate: d,
    revision: u
  };
  return JSON.stringify({
    esriConfig: s,
    loaderConfig: l,
    kernelInfo: f
  });
}

var P = 0;
export { v as createWorker };